import { render, staticRenderFns } from "./EditDaftarPeriksa.vue?vue&type=template&id=41ac2e8c&"
import script from "./EditDaftarPeriksa.vue?vue&type=script&lang=js&"
export * from "./EditDaftarPeriksa.vue?vue&type=script&lang=js&"
import style0 from "./EditDaftarPeriksa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports